import { SquaresPlusIcon } from '@heroicons/react/24/solid';
import Utilities from '@util/Utilities';
import React from 'react';
import { Tooltip } from 'react-tooltip';
import Competitor from '@app/model/company_hotel/Competitor';

const DisplayGroupName: React.FunctionComponent<{ group: Competitor }> = ({ group }) => {

	const tooltipId = 'group-' + group.id;

	return <>
		<div
			className="inline-flex items-center rounded-md bg-gray-50 text-xs font-medium text-gray-600 ring-1 ring-gray-500/20 cursor-pointer"
			data-tooltip-id={tooltipId}>
			<span className="px-1.5 py-0.5">{Utilities.trim(group.name, 40)}</span>
			<span className="px-1.5 py-0.5 bg-blue-50 border border-l border-blue-100">
				<SquaresPlusIcon
					className="w-3.5 h-3.5" />
		</span>
		</div>
		{<Tooltip id={tooltipId}
							className="shadow-lg z-50 !p-0 !opacity-100">
			<div className="flex flex-col gap-y-2 p-2">
				Group of {group.competitors.length} listings
			</div>
		</Tooltip>}
	</>;
};

export default DisplayGroupName;